import AMD from "../assets/currencies/AMD.svg";
import USD from "../assets/currencies/USD.svg";
import EUR from "../assets/currencies/EUR.svg";
import RUB from "../assets/currencies/RUB.svg";
import AED from "../assets/currencies/AED.svg";
import CNY from "../assets/currencies/CNY.svg";
import BYN from "../assets/currencies/BYN.svg";
import ZAR from "../assets/currencies/ZAR.svg";
import KZT from "../assets/currencies/KZT.svg";
import GBP from "../assets/currencies/GBP.svg";
import HKD from "../assets/currencies/HKD.svg";
import CHF from "../assets/currencies/CHF.svg";
import CAD from "../assets/currencies/CAD.svg";
import AUD from "../assets/currencies/AUD.svg";

export const CURRENCY_FLAGS: Record<string, string> = {
  AMD,
  USD,
  EUR,
  RUB,
  AED,
  CNY,
  BYN,
  ZAR,
  KZT,
  GBP,
  HKD,
  CHF,
  CAD,
  AUD,
  // CUP,
  // ARS,
  // BHD,
  // BRL,
  // DOP,
  // EGP,
  // GEL,
  // INR,
  // IQD,
  // IRR,
  // JPY,
  // KPW,
  // KWD,
  // KYD,
  // MAD,
  // MXN,
  // NOK,
  // NZD,
  // OMR,
  // PHP,
  // PLN,
  // QAR,
  // SAR,
  // SCR,
  // SEK,
  // SGD,
  // SYP,
  // UAH,
};
